export default __webpack_public_path__ + "static/media/qandanswer.63aac7b9f7f927666103fdbd3991685f.svg";